import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { TrapezoidConstraintValidator } from "@/Models/Validators/TrapezoidConstraintValidator";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';
import AbstractShape, { Dimensions } from '../Shapes/AbstractShape';
import { ValidatorInterface } from '../Validators/ValidatorInterface';

export default class TrapezoidConfiguration implements ShapeConfigurationInterface {
	public hasNewValidators = true;

	get_dimension_keys(): string[] {
		return [
			'width_top',
			'width_bottom',
			'height',
			'offset_left',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			width_top: maximum_rectangle.get_longest_side(),
			width_bottom: maximum_rectangle.get_longest_side(),
			height: maximum_rectangle.get_longest_side(),
			offset_left: maximum_rectangle.get_longest_side(),
		};
	}

	get_labels(): Record<string, string> {
		const { width_top, width_bottom, height, offset_left } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			width_top,
			width_bottom,
			height,
			offset_left,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			height: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			width_top: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			width_bottom: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_new_validators( instance: AbstractShape, minimum: number, maximums: Record<string, Length>, dimensions: Dimensions ): ValidatorInterface[] {
		return [
			new MaximumDecimalPoints( {
				field: 'trapezoid-height',
				dimension: 'height',
				decimalPoints: 1,
				instance,
			} ),
			new MaximumDecimalPoints( {
				field: 'trapezoid-width_top',
				dimension: 'width_top',
				decimalPoints: 1,
				instance,
			} ),
			new MaximumDecimalPoints( {
				field: 'trapezoid-width_bottom',
				dimension: 'width_bottom',
				decimalPoints: 1,
				instance,
			} ),
			new MaximumValue( {
				field: 'trapezoid-width_top',
				dimension: 'width_top',
				instance,
				maximums,
			} ),
			new MaximumValue( {
				field: 'trapezoid-width_bottom',
				dimension: 'width_bottom',
				instance,
				maximums,
			} ),
			new MaximumValue( {
				field: 'trapezoid-height',
				dimension: 'height',
				instance,
				maximums,
			} ),
			new MinimumValue( {
				field: 'trapezoid-width_top',
				dimension: 'width_top',
				minimum,
				instance,
			} ),
			new MinimumValue( {
				field: 'trapezoid-width_bottom',
				dimension: 'width_bottom',
				minimum,
				instance,
			} ),
			new MinimumValue( {
				field: 'trapezoid-height',
				dimension: 'height',
				minimum,
				instance,
			} ),
			new TrapezoidConstraintValidator( {
				field: 'trapezoid-constraint',
				dimension: 'height',
				instance,
				maximums,
			} )
		];
	}

	get_category(): ShapeCategory {
		return 'straight';
	}
}
